import React, { memo } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Grid from '../../helpers/AgGridTable';
import config from '../../../config';
import { RowIndex } from '../RowIndex';
import { CompanyCell } from '../CompanyCell';
import { PlainPriority } from '../PlainPriority';
import { Sales } from '../Sales';
import { Products } from '../Products';
import { Markets } from '../Markets';
import { Facilities } from '../Facilities';
import { CustomFields } from '../CustomFields';
import { Description } from '../Description';
import { GridCard } from '../../helpers/GridCard';

import style from './style.module.css';

const PreviewBodySection = ({ onlineApproval }) => {
  const optionalFields = [];
  const searchParams = new URLSearchParams(window.location.search);

  let api = null;

  for (const value of searchParams.keys()) {
    optionalFields.push(value);
  }

  const columnDefs = config.tables.getIn(['approval', 'online']).map(column => {
    if (optionalFields.includes(column.get('field'))) {
      // eslint-disable-next-line no-param-reassign
      column = column.set('hide', false);
    }

    switch (column.get('field')) {
      case 'index':
        return column.merge({
          cellRendererFramework: RowIndex,
        });

      case 'companyLegalName':
        return column.merge({
          cellRendererFramework: CompanyCell,
        });

      case 'companyDescription':
        return column.merge({
          cellRendererFramework: Description,
        });

      case 'products':
        return column.merge({
          cellRendererFramework: Products,
        });

      case 'markets':
        return column.merge({
          cellRendererFramework: Markets,
        });

      case 'facilities':
        return column.merge({
          cellRendererFramework: Facilities,
        });

      case 'custom_fields':
        return column.merge({
          cellRendererFramework: CustomFields,
        });

      case 'companyRevenue':
        return column.merge({
          cellRendererFramework: Sales,
        });

      case 'priority':
        return column.merge({
          cellRendererFramework: PlainPriority,
        });

      default:
        return column;
    }
  });

  const rowData = onlineApproval.get('approvalListData');

  const handleGridReady = params => {
    api = params.api;
    api.sizeColumnsToFit();
  };

  const handleGridSizeChanged = () => {
    if (api) {
      api.sizeColumnsToFit();
    }
  };

  const getRowNodeId = data => data.id;

  return (
    <GridCard className={style.host}>
      <Grid
        columnDefs={columnDefs}
        getRowNodeId={getRowNodeId}
        onGridReady={handleGridReady}
        onGridSizeChanged={handleGridSizeChanged}
        rowData={rowData}
        rowHeight={130}
      />
    </GridCard>
  );
};

PreviewBodySection.propTypes = {
  onlineApproval: PropTypes.instanceOf(Map).isRequired,
};

export default memo(PreviewBodySection);
